import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  useDisclosure,
} from "@heroui/react";
import { Debug, FlagCategory } from "@sc07-canvas/lib/debug";
import { useEffect } from "react";

import { Button } from "../core/Button";
import { Switch } from "../core/Switch";

export const DebugModal = () => {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  useEffect(() => {
    const handleOpen = () => {
      onOpen();
    };

    Debug.on("openTools", handleOpen);

    return () => {
      Debug.off("openTools", handleOpen);
    };
  }, []);

  return (
    <Modal isOpen={isOpen} onOpenChange={onOpenChange} placement="center">
      <ModalContent className="canvas-overlay-card">
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1">
              Debug Tools
            </ModalHeader>
            <ModalBody>
              <Button onPress={() => Debug.openDebug()}>
                Open Debug Information
              </Button>
              {Debug.flags.getAll().map((flag, i, arr) => (
                <>
                  {arr[i - 1]?.category !== flag.category && (
                    <p>{FlagCategory[flag.category]}</p>
                  )}
                  <div key={flag.id}>
                    <Switch
                      defaultSelected={flag.enabled}
                      onValueChange={(v) => {
                        Debug.flags.setEnabled(flag.id, v);
                      }}
                    >
                      {flag.id}
                    </Switch>
                  </div>
                </>
              ))}
            </ModalBody>
            <ModalFooter>
              <Button onPress={onClose}>Close</Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};
